<script lang="ts">
    import { VpAddIcon } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';
    import Button from '$saga/components/Button.svelte';

    export let roomCount: number;
    export let canIncrement: boolean;
    export let onAdd: () => void;

    const MAX_ROOMS = 5;

    $: canAddRoom = canIncrement && roomCount < MAX_ROOMS;
</script>

<Button
    class="self-center"
    type="button"
    intent="tertiary"
    size="small"
    disabled={!canAddRoom}
    startIcon={VpAddIcon}
    on:click={onAdd}
>
    {trans('tour.aside_panel.travelgate.add_room')}
</Button>
